import * as ActionTypes from './actionTypes'

export const hideTimeoutWarningAction = (stateLocation) =>
{
    return {
        type: ActionTypes.hideTimeoutWarning,
        payload:
        {
            stateLocation
        }
    }
};
export function setMinimize(isMinimized, stateLocation)
{
    return {
        type: ActionTypes.setMinimizeWindow,
        payload: {
            value: isMinimized,
            stateLocation,
        },
    };
}


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/timeout-warning-overlay/src/actions/actions.js